import { render } from "./WithIcon.vue?vue&type=template&id=147981f5"
import script from "./WithIcon.vue?vue&type=script&lang=js"
export * from "./WithIcon.vue?vue&type=script&lang=js"

import "./WithIcon.vue?vue&type=style&index=0&id=147981f5&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__